import { useState } from 'react';
import { useLanguage } from '../useLanguage';

const Contact = () => {
  const { t } = useLanguage();
  // const [formData, setFormData] = useState({
  //   name: '',
  //   email: '',
  //   company: '',
  //   message: '',
  //   projectType: 'consultation',
  // });
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted] = useState(false);
  const [emailRevealed, setEmailRevealed] = useState('');
  
  const revealEmail = () => {
    const scrambled = 'moc.liamg@izerauj.nimajneb';
    const email = scrambled.split('').reverse().join('');
    setEmailRevealed(email);
  };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
    
  //   // Simulate form submission
  //   await new Promise(resolve => setTimeout(resolve, 1000));
    
  //   setSubmitted(true);
  //   setIsSubmitting(false);
    
  //   // Reset form after 3 seconds
  //   setTimeout(() => {
  //     setSubmitted(false);
  //     setFormData({
  //       name: '',
  //       email: '',
  //       company: '',
  //       message: '',
  //       projectType: 'consultation',
  //     });
  //   }, 3000);
  // };

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
  //   setFormData(prev => ({
  //     ...prev,
  //     [e.target.name]: e.target.value
  //   }));
  // };

  if (submitted) {
    return (
      <section id="contact" className="section-padding bg-gray-50 dark:bg-dark-800">
        <div className="max-w-4xl mx-auto text-center">
          <div className="card p-12">
            <div className="text-6xl mb-6">✅</div>
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              {t.contact.messageSent}
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              {t.contact.thankYou}
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="contact" className="section-padding bg-gray-50 dark:bg-dark-800">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            {t.contact.title}
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            {t.contact.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div className="card p-6">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6">
              {t.contact.getInTouch}
            </h3>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-4 hover:bg-gray-50 dark:hover:bg-dark-700 p-2 rounded-lg transition-colors">
                <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/20 rounded-lg flex items-center justify-center">
                  <span className="text-xl font-bold text-primary-600 dark:text-primary-400">@</span>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white">{t.contact.email}</h4>
                  {emailRevealed ? (
                    <p className="text-gray-600 dark:text-gray-400">{emailRevealed}</p>
                  ) : (
                    <button
                      onClick={revealEmail}
                      className="text-secondary-600 dark:text-secondary-400 hover:underline"
                    >
                      {t.contact.clickToReveal}
                    </button>
                  )}
                </div>
              </div>

              <div className="flex items-center space-x-4 hover:bg-gray-50 dark:hover:bg-dark-700 p-2 rounded-lg transition-colors">
                <div className="w-12 h-12 bg-secondary-100 dark:bg-secondary-900/20 rounded-lg flex items-center justify-center">
                  <span className="text-xl font-bold text-secondary-600 dark:text-secondary-400">■</span>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white">{t.contact.scheduleCall}</h4>
                  <a
                    href="https://calendly.com/benjamin-juarez/60min"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-secondary-600 dark:text-secondary-400 hover:underline"
                  >
                    {t.contact.bookConsultation}
                  </a>
                </div>
              </div>

              <div className="flex items-center space-x-4 hover:bg-gray-50 dark:hover:bg-dark-700 p-2 rounded-lg transition-colors">
                <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/20 rounded-lg flex items-center justify-center">
                  <span className="text-xl font-bold text-blue-600 dark:text-blue-400">in</span>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white">{t.contact.linkedin}</h4>
                  <a
                    href="https://www.linkedin.com/in/benjamin-juarez-4826862a/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 dark:text-blue-400 hover:underline"
                  >
                    {t.contact.connectProfessionally}
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Value Proposition */}
          <div className="card p-6">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              {t.contact.whyFractional}
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <span className="text-green-500">✓</span>
                <span className="text-gray-700 dark:text-gray-300">{t.contact.costSavings}</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="text-green-500">✓</span>
                <span className="text-gray-700 dark:text-gray-300">{t.contact.immediateAccess}</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="text-green-500">✓</span>
                <span className="text-gray-700 dark:text-gray-300">{t.contact.flexibleEngagement}</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="text-green-500">✓</span>
                <span className="text-gray-700 dark:text-gray-300">{t.contact.clientSatisfaction}</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="text-green-500">✓</span>
                <span className="text-gray-700 dark:text-gray-300">{t.contact.responseGuarantee}</span>
              </li>
            </ul>
          </div>

          {/* Next Steps */}
          <div className="card p-6">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              {t.contact.nextSteps}
            </h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-primary-600 dark:text-primary-400">1</span>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white">{t.contact.discoveryCall}</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{t.contact.discoveryDesc}</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-primary-600 dark:text-primary-400">2</span>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white">{t.contact.technicalAssessment}</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{t.contact.assessmentDesc}</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary-100 dark:bg-primary-900/30 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-primary-600 dark:text-primary-400">3</span>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white">{t.contact.strategicImplementation}</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{t.contact.implementationDesc}</p>
                </div>
              </div>
            </div>
          </div>


        </div>

        {/* Final CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 dark:from-dark-800 dark:to-dark-900 text-white p-8 rounded-2xl shadow-xl">
            <h3 className="text-2xl font-bold mb-4">{t.contact.startTransformation}</h3>
            <p className="text-lg mb-6 opacity-90 max-w-2xl mx-auto">
              {t.contact.transformationDesc}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://calendly.com/benjamin-juarez/60min"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary-500 hover:bg-primary-600 text-white font-bold py-4 px-8 rounded-lg transition-all duration-200 hover:scale-105 inline-flex items-center justify-center space-x-2 shadow-lg"
              >
                <span>{t.contact.bookFreeCall}</span>
              </a>
            </div>
            <p className="text-sm opacity-75 mt-4">
              {t.contact.responseTime}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;